import { withNavigationWatcher } from "./contexts/navigation";
import Home from "./pages/Home/Home";
import NewProfiles from "./pages/AllProfiles/NewProfiles";
import AllProfiles from "./pages/AllProfiles/AllProfiles";
import AdminUsers from "./pages/AdminUsers/AdminUsers";
import EditProfiles from "./pages/AllProfiles/EditProfiles";
import FailProfiles from "./pages/AllProfiles/FailProfiles";
import BlockedProfiles from "./pages/AllProfiles/BlockedProfiles";
import DellProfiles from "./pages/AllProfiles/DellProfiles";
import Reports from "./pages/Reports/Reports";
import Orders from "./pages/Orders/Orders";
import OrderDiscounts from "./pages/OrderDiscounts/OrderDiscounts";
import Config from "./pages/Config/Config";
import Broadcasts from "./pages/Broadcasts/Broadcasts";

const routes = [
	{
		path: "/",
		element: Home,
	},
	{
		path: "/all-profiles",
		element: AllProfiles,
	},
	{
		path: "/new-profiles",
		element: NewProfiles,
	},
	{
		path: "/edit-profiles",
		element: EditProfiles,
	},
	{
		path: "/fail-profiles",
		element: FailProfiles,
	},
	{
		path: "/blocked-profiles",
		element: BlockedProfiles,
	},
	{
		path: "/deleted-profiles",
		element: DellProfiles,
	},
	{
		path: "/users",
		element: AdminUsers,
	},
	{
		path: "/reports",
		element: Reports,
	},
	{
		path: "/orders",
		element: Orders,
	},
	{
		path: "/order-discounts",
		element: OrderDiscounts,
	},
	{
		path: "/config",
		element: Config,
	},
	{
		path: "/broadcasts",
		element: Broadcasts,
	},
];

export default routes.map((route) => {
	return {
		...route,
		element: withNavigationWatcher(route.element, route.path),
	};
});
